import { hasPermission } from "utils/common";

export function getManualClassificationEnabled(state){
	return !!state.libraryProperties?.advertiserId;
}

export function getAdvertiserAutoClassificationEnabled(state){
	const autoClassification = state.advertiserDetails?.data?.creativeTaxonomy?.autoClassification;
	return autoClassification && autoClassification !== "No Auto-Classification";
}

export function getLibraryAutoClassificationEnabled(state){
	return state.libraryProperties?.isClassificationEnabled;
}

export function getAutoClassificationEnabled(state){
	const advertiserEnabled = getAdvertiserAutoClassificationEnabled(state);
	const libraryEnabled = getLibraryAutoClassificationEnabled(state);
	const hasLibraryEditPermission = hasPermission(state.you, "Creative Library", "Edit");

	return advertiserEnabled && libraryEnabled && hasLibraryEditPermission;
}

export function getRemainingCredits(state){
	return state.advertiserDetails?.data?.creativeTaxonomy?.remainingCredits || 0;
}
